var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWindow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 300",
    style: {
      enableBackground: "new 0 0 600 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#486F87;stroke-width:15;stroke-miterlimit:10;}\n\t.st1{fill:#AAD4F1;}\n\t.st2{fill:#D5D4D4;}\n\t.st3{fill:#BFBEBE;}\n\t.st4{fill:#E5E6E6;}\n\t.st5{fill:none;stroke:#BBBDBE;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#6E94AF;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-miterlimit:10;}\n\t.st9{fill:#6E95AF;}\n\t.st10{fill:#1B4E7F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,258L300,258c-35.44,0-64.18-28.73-64.18-64.18V96.9c0-35.44,28.73-64.18,64.18-64.18h0 c35.44,0,64.18,28.73,64.18,64.18v96.93C364.18,229.27,335.44,258,300,258z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.82,248.86L299.82,248.86c-30.66,0-55.52-24.86-55.52-55.52V98.03c0-30.66,24.86-55.52,55.52-55.52h0 c30.66,0,55.52,24.86,55.52,55.52v95.31C355.34,224.01,330.49,248.86,299.82,248.86z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "275.9,244.45 331.47,241.35 328.56,231.88 293.39,212.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "275.25,245.67 327.48,240.75 324.57,234.19 290.66,217.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251.03,170.09 329.74,120.16 348.33,81.17 353.9,81.19 345.77,120.16 275.81,245.98 254.74,226.4  244.95,187.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "301.65,199.81 339.55,198.71 337.73,189.6 315.13,175.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "301.54,200.24 334.93,199.28 333.33,191.25 313.42,178.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "329.74,120.16 345.77,120.16 353.42,82.15 348.33,81.17  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 243.26,
    y1: 202.64,
    x2: 277.27,
    y2: 174.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 254.82,
    y1: 223.75,
    x2: 304.48,
    y2: 158.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 269.19,
    y1: 241.33,
    x2: 303.99,
    y2: 182.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 266.88,
    y1: 183.48,
    x2: 281.15,
    y2: 189.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 248.11,
    y1: 199.24,
    x2: 263.18,
    y2: 212.84
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.64,39.4L299.64,39.4c-32.09,0-58.1,26.01-58.1,58.1v95.49c0,32.09,26.01,58.1,58.1,58.1h0 c32.09,0,58.1-26.01,58.1-58.1V97.5C357.74,65.41,331.73,39.4,299.64,39.4z M349.4,190.35c0,26.98-22.28,48.84-49.76,48.84h0 c-27.48,0-49.76-21.87-49.76-48.84v-90.22c0-26.98,22.28-48.84,49.76-48.84h0c27.48,0,49.76,21.87,49.76,48.84V190.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.92,258L134.92,258c-35.44,0-64.18-28.73-64.18-64.18V96.9c0-35.44,28.73-64.18,64.18-64.18h0 c35.44,0,64.18,28.73,64.18,64.18v96.93C199.1,229.27,170.37,258,134.92,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.75,248.86L134.75,248.86c-30.66,0-55.52-24.86-55.52-55.52V98.03c0-30.66,24.86-55.52,55.52-55.52h0 c30.66,0,55.52,24.86,55.52,55.52v95.31C190.26,224.01,165.41,248.86,134.75,248.86z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.2,217.3h-51.69c-4.83,0-8.75-4.22-8.75-9.41v0c0-5.2,3.92-9.41,8.75-9.41h51.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M188.05,205.78h-30.81c-2.88,0-5.21-4.22-5.21-9.41v0c0-5.2,2.33-9.41,5.21-9.41h30.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.63,100.07h25.81c2.41,0,4.37,4.22,4.37,9.41v0c0,5.2-1.96,9.41-4.37,9.41H78.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.39,88.54h49.33c4.61,0,8.35,4.22,8.35,9.41v0c0,5.2-3.74,9.41-8.35,9.41H78.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M134.57,39.4L134.57,39.4c-32.09,0-58.1,26.01-58.1,58.1v95.49c0,32.09,26.01,58.1,58.1,58.1h0 c32.09,0,58.1-26.01,58.1-58.1V97.5C192.67,65.41,166.65,39.4,134.57,39.4z M184.32,190.35c0,26.98-22.28,48.84-49.76,48.84h0 c-27.48,0-49.76-21.87-49.76-48.84v-90.22c0-26.98,22.28-48.84,49.76-48.84h0c27.48,0,49.76,21.87,49.76,48.84V190.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.08,258L465.08,258c-35.44,0-64.18-28.73-64.18-64.18V96.9c0-35.44,28.73-64.18,64.18-64.18h0 c35.44,0,64.18,28.73,64.18,64.18v96.93C529.26,229.27,500.52,258,465.08,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.9,248.86L464.9,248.86c-30.66,0-55.52-24.86-55.52-55.52V98.03c0-30.66,24.86-55.52,55.52-55.52h0 c30.66,0,55.52,24.86,55.52,55.52v95.31C520.42,224.01,495.57,248.86,464.9,248.86z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M515.36,217.3h-51.69c-4.83,0-8.75-4.22-8.75-9.41v0c0-5.2,3.92-9.41,8.75-9.41h51.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M518.21,205.78H487.4c-2.88,0-5.21-4.22-5.21-9.41v0c0-5.2,2.33-9.41,5.21-9.41h30.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M408.79,100.07h25.81c2.41,0,4.37,4.22,4.37,9.41v0c0,5.2-1.96,9.41-4.37,9.41h-25.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M408.55,88.54h49.33c4.61,0,8.35,4.22,8.35,9.41v0c0,5.2-3.74,9.41-8.35,9.41h-49.33"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M464.72,39.4L464.72,39.4c-32.09,0-58.1,26.01-58.1,58.1v95.49c0,32.09,26.01,58.1,58.1,58.1h0 c32.09,0,58.1-26.01,58.1-58.1V97.5C522.82,65.41,496.81,39.4,464.72,39.4z M514.48,190.35c0,26.98-22.28,48.84-49.76,48.84h0 c-27.48,0-49.76-21.87-49.76-48.84v-90.22c0-26.98,22.28-48.84,49.76-48.84h0c27.48,0,49.76,21.87,49.76,48.84V190.35z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWindow);
export default __webpack_public_path__ + "static/media/icon-window.edcfb665350be10a8c43c1c8d4465c08.svg";
export { ForwardRef as ReactComponent };